import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ItemTitle from './components/ItemTitle/ItemTitle.desktop';
import ItemDescriptionCard from './components/ItemDescriptionCard/ItemDescriptionCard.desktop';
import ProfileCard from './components/ProfileCard/ProfileCard';
import CallToActionCard from './components/CallToActions/CallToActionCard';
import ImageGallery from 'Components/ImageGallery/ImageGallery';
import { Card } from 'panamera-react-ui';
import AsyncRelatedAds from './components/RelatedAds/AsyncRelatedAds';
import css from './Item.scss';
import { css as uiCss } from 'panamera-react-ui';
import { getUserImage } from 'Helpers/images';
import FavoriteButton from './components/FavoriteButton/FavoriteButton';
import ShareButton from './components/ShareButton/ShareButton';
import { injectIntl } from 'react-intl';
import ReportAd from './components/ReportAd/ReportAd';
import { CTA_CONFIGS_MAP, CTA_MAP, ITEM_FULL_SCREEN_HASH } from 'Constants/items';
import withConfig from 'HOCs/withConfig/withConfig';
import StaticMapWrapper from 'Components/StaticMap/StaticMapWrapper';
import withFeatureFlags from 'HOCs/withFeatureFlags/withFeatureFlags';
import { getGoogleMapsDestinationURL } from 'Constants/googleMaps';
import { CONFIG } from 'Constants/config';
import { CATEGORIES_IDS } from 'Constants/categories';
import { checkUserMembership } from 'Helpers/premiumUser';
import AsyncRelatedArticles from './components/RelatedArticles/AsyncRelatedArticles';
import { getFeaturedAdSelector } from 'Selectors/items';
import { connect } from 'react-redux';

const { grid } = uiCss;

export class AdpvOld extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        user: PropTypes.object,
        isFullItem: PropTypes.bool,
        location: PropTypes.object,
        isMyItem: PropTypes.bool,
        parameters: PropTypes.array,
        isItemOutdated: PropTypes.bool,
        getMonetizerCard: PropTypes.func.isRequired,
        getLimitsCard: PropTypes.func.isRequired,
        renderBanners: PropTypes.func,
        renderLocationPath: PropTypes.func.isRequired,
        language: PropTypes.string,
        onTrackMap: PropTypes.func.isRequired,
        onClickReport: PropTypes.func.isRequired,
        toggleFirstTimeUserTips: PropTypes.func.isRequired,
        tipsInitiationPoint: PropTypes.string,
        onTrack: PropTypes.func.isRequired,
        getTrackingInfo: PropTypes.func.isRequired,
        trackImageTap: PropTypes.func,
        trackImagePagination: PropTypes.func,
        onMessageSend: PropTypes.func,
        loggedUser: PropTypes.shape({
            id: PropTypes.string
        }),
        intl: PropTypes.shape({
            formatMessage: PropTypes.func.isRequired
        }).isRequired,
        leadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }),
        onViewRelatedAd: PropTypes.func,
        showIvrNumberOnAdpv: PropTypes.bool,
        showRequestCallbackOnAdpv: PropTypes.bool,
        showInterestOnAdpv: PropTypes.bool,
        showStoreTestdriveOnAdpv: PropTypes.bool,
        showChatOnAdpv: PropTypes.bool,
        showCallOnAdpv: PropTypes.bool,
        showOfferOnAdpv: PropTypes.bool,
        isLamudi: PropTypes.bool,
        isShowCoachMark: PropTypes.bool,
        onCloseMarkCoach: PropTypes.func,
        isShowReservationButton: PropTypes.bool,
        isItemReserved: PropTypes.bool,
        showWhatsAppCTA: PropTypes.bool,
        escrowTrack: PropTypes.func,
        renderBookingModal: PropTypes.func
        // isFeatured: PropTypes.bool
    };

    static defaultProps = {
        isFullItem: false,
        leadFormName: '',
        leadFormFlow: () => {},
        trackImageTap: () => {},
        trackImagePagination: () => {},
        showRequestCallbackOnAdpv: false,
        showInterestOnAdpv: false,
        showChatOnAdpv: false,
        showCallOnAdpv: false,
        showOfferOnAdpv: false,
        showStoreTestdriveOnAdpv: false,
        showIvrNumberOnAdpv: false,
        renderBookingModal: () => {}
    };

    isOlxMobbi = this.props.config.get('isOlxMobbi');

    renderActionButtons = () => {
        const { showFavBtn, showSocialShareBtn } = this.props.config.get('adpvAuto') || {};

        return (
            <div className={ css.actionButtons }>
                { showSocialShareBtn && <ShareButton
                    path={ this.props.location.pathname }
                    title={ this.props.item.title }
                    description={ this.props.item.description }
                    isMyItem={ this.props.isMyItem }
                    isItemOutdated={ this.props.isItemOutdated }
                    itemId={ this.props.item.id }
                    getTrackingInfo={ this.props.getTrackingInfo }

                />}
                { !this.props.isMyItem && showFavBtn
                && <FavoriteButton
                    name="Favorite"
                    item={ this.props.item }
                    getTrackingInfo={ this.props.getTrackingInfo }
                />
                }
            </div>
        );
    }

    renderGalleryDescription = () => {
        const {
            item,
            isMyItem,
            isItemOutdated,
            parameters,
            loggedUser,
            isFullItem,
            config
        } = this.props;
        const {
            id,
            images,
            title,
            price,
            description,
            user_id
        } = item;
        const staticAssetUrl = config.get(CONFIG.STATIC_ASSETS);
        const isMotorBekas = item.category_id === '200';

        return (
            <div className={ `${grid.col} ${grid.margin} ${grid.xl8} ${grid.l12} ${grid.m12} ${grid.s12} ` }>
                { images.length > 0
                    && <ImageGallery
                        className={ css.imageGallery }
                        showFavouriteButton
                        images={ images }
                        getTrackingInfo={ this.props.getTrackingInfo }
                        trackImageTap={ this.props.trackImageTap }
                        trackImagePagination={ this.props.trackImagePagination }
                        title={ title }
                        userID={ this.props.user.id }
                        price={ price ? price.value.display : '' }
                        isMyItem={ isMyItem }
                        isItemOutdated={ isItemOutdated }
                        imageSize="850"
                        itemId={ this.props.item.id }
                        fullScreenHash={ ITEM_FULL_SCREEN_HASH }
                        showSliderArrows
                        staticAssetUrl={ staticAssetUrl }
                        monetizationInfo={ item.monetizationInfo }
                        showFeaturedTag
                    />
                }
                { this.props.getLimitsCard('mobile') }
                <ItemDescriptionCard
                    description={ description }
                    parameters={ parameters }
                    key={ `itemId_${id}-userId_${user_id}` }
                    isLamudi={ this.props.isLamudi }
                />
                { isFullItem && !this.isOlxMobbi && (
                    <AsyncRelatedAds
                        item={ item }
                        onTrack={ this.props.onTrack }
                        loggedUser={ loggedUser }
                        isAdPostedByPremiumUser={ checkUserMembership(this.props.user?.subscription_info?.type) }
                        getPreferredOrSimilarAdsForPremiumUser={ true }
                    />
                )}
                { isFullItem && (
                    <AsyncRelatedAds
                        item={ item }
                        onTrack={ this.props.onTrack }
                        loggedUser={ loggedUser }
                        onViewRelatedAd={ this.props.onViewRelatedAd }
                    />
                )}
                {!this.isOlxMobbi && isMotorBekas && <AsyncRelatedArticles className={ css.relatedArticleClassified } parameters={ parameters } titleClassName={ css.relatedArticleClassifiedTitle } />}
            </div>
        );
    };

    renderProfileDetailsMap = () => {
        const { item, isMyItem, isItemOutdated, language, renderLocationPath, onTrackMap, intl, config, isShowReservationButton, isShowCoachMark, onCloseMarkCoach, isItemReserved, escrowTrack } = this.props;
        const { id, title, price, user_id, status, valid_to, created_at, created_at_first, locations, display_date, category_id, 'package': appliedPackage, monetizationInfo } = item;
        const postedIn = intl.formatMessage({ id: 'postedIn' });
        const staticAssetUrl = config.get('staticAssets');
        const carCategoryId = config.get('adpvAuto', 'carCategory');
        const latitude = String(locations[0].lat);
        const longitude = String(locations[0].lon);
        const googleMapURL = (item?.category_id === carCategoryId && latitude && longitude) ? getGoogleMapsDestinationURL(latitude, longitude) : '';
        const nibText = `${intl.formatMessage({ id: 'nibText' })}:`;
        const discountedPrice = item && item?.has_promotion && item?.price?.value?.discounted_price ? item?.price?.value?.discounted_price?.display : 0;
        const isFeatured = (appliedPackage && (appliedPackage.id || appliedPackage.name)) || monetizationInfo?.currentProduct;

        return (
            <div className={ `${grid.col} ${grid.margin} ${grid.xl4} ${grid.l12} ${grid.m12} ${grid.s12}` }>
                { this.props.getMonetizerCard() }
                { this.props.getLimitsCard('desktop') }
                {
                    <Card className={ css.itemTitle }>
                        <ItemTitle
                            title={ title }
                            price={ price ? price.value.display : '' }
                            ItemPackage={ item.package ? item.package.name : '' }
                            renderLocationPath={ renderLocationPath }
                            mainInfo={ item.main_info }
                            itemCreationDate={ display_date || created_at_first || created_at }
                            isShowReservationButton={ isShowReservationButton } // props for show button reservation when item enabled escrow
                            isShowCoachMark={ isShowCoachMark } // props for show coachmark when item enabled escrow & user first time visit adpv
                            onCloseMarkCoach={ onCloseMarkCoach } // props function to skip or close coachmark when item enabled escrow & user first time visit adpv
                            categoryId={ category_id }
                            isItemReserved={ isItemReserved } // disabled button reservation when item is reserved
                            escrowTrack={ escrowTrack }
                            sellerMemberType={ this.props.user?.subscription_info?.type || '' }
                            showFeaturedTag={ isFeatured }
                            showDiscountBadge={ item?.has_promotion }
                            discountTagValue={ item?.price?.value?.discount_tag }
                            actionButtonComponents={ this.renderActionButtons() }
                            discountedPrice={ discountedPrice.toString() }
                            monetizationInfo={ monetizationInfo }
                        />
                    </Card>
                }
                {
                    <Card className={ css.itemCard }>
                        { this.props.isFullItem
                            && <ProfileCard
                                avatar={ getUserImage(staticAssetUrl, this.props.user) }
                                name={ this.props.user.name }
                                id={ this.props.user.id }
                                itemId={ id }
                                toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                                onMessageSend={ this.props.onMessageSend }
                                tipsInitiationPoint={ this.props.tipsInitiationPoint }
                                itemUserId={ user_id }
                                onTrack={ this.props.onTrack }
                                getTrackingInfo={ this.props.getTrackingInfo }
                                itemStatus={ status }
                                isMyItem={ isMyItem }
                                leadFormName={ this.props.leadFormName }
                                leadFormFlow={ this.props.leadFormFlow }
                                buttonContactType={ 'primary' }
                                showSeePhoneNumber={ this.props.showIvrNumberOnAdpv }
                                showCallRequest={ this.props.showRequestCallbackOnAdpv }
                                showWhatsAppCTA={ this.props.showWhatsAppCTA }
                                showInterest={ this.props.showInterestOnAdpv }
                                showChat={ this.props.showChatOnAdpv }
                                showCall={ this.props.showCallOnAdpv }
                                showMakeOffer={ this.props.showOfferOnAdpv }
                                showTestDrive={ this.props.showStoreTestdriveOnAdpv }
                                ctaConfigSetup={ this.ctaConfigSetup }
                                primaryCTA={ this.primaryCTA }
                            />
                        }
                        <CallToActionCard
                            onTrack={ this.props.onTrack }
                            itemUserId={ user_id }
                            userId={ (this.props.loggedUser && this.props.loggedUser.id) || '' }
                            itemId={ id }
                            itemStatus={ status }
                            isMyItem={ isMyItem }
                            isItemOutdated={ isItemOutdated }
                            itemValidTo={ valid_to }
                        />
                        { CATEGORIES_IDS.RE_PROPERTIES.indexOf(this.props.item.category_id) !== -1 && this.props?.user?.nib_number
                            && <div className={ css.nibNumberContainer }>
                                <div className={ css.nibNumber }>
                                    <div>
                                        {nibText}
                                    </div>
                                    <div>
                                        {this.props.user.nib_number}
                                    </div>
                                </div>
                            </div>
                        }
                    </Card>
                }
                { this.props.renderBanners('middle') }
                <Card className={ css.map } onClick={ onTrackMap }>
                    <h3 className={ css.mapTitle }>{ postedIn }</h3>
                    { renderLocationPath() }
                    <StaticMapWrapper
                        latitude={ latitude }
                        longitude={ longitude }
                        circle={ true }
                        language={ language }
                        circleClassName={ css.googleMapCircle }
                        href={ googleMapURL }
                    />
                </Card>
                { !this.props.isMyItem && (
                    <ReportAd
                        itemId={ this.props.item.id }
                        onClick={ this.props.onClickReport } />
                )}
                { this.props.renderBanners('middle-bottom') }
                { this.props.renderBanners('bottom') }
            </div>
        );
    };

    getCTAConfigs = () => {
        const {
            showInterestOnAdpv,
            showRequestCallbackOnAdpv,
            showIvrNumberOnAdpv,
            showChatOnAdpv,
            showCallOnAdpv,
            showStoreTestdriveOnAdpv,
            showWhatsAppCTA,
            isShowReservationButton
        } = this.props;

        this.primaryCTA = '';

        const CTA_CONFIGS = JSON.parse(JSON.stringify(CTA_CONFIGS_MAP)); // CREATING CP OF CONFIGS

        if (showInterestOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_INTEREST_CTA;
            CTA_CONFIGS.SHOW_INTEREST_CTA.isActive = true;
        }
        if (showRequestCallbackOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CALL_REQUEST_CTA;
            CTA_CONFIGS.SHOW_CALL_REQUEST_CTA.isActive = true;
        }
        if (showIvrNumberOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_SEE_PHONE_NUMBER_CTA;
            CTA_CONFIGS.SHOW_SEE_PHONE_NUMBER_CTA.isActive = true;
        }
        if (showStoreTestdriveOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_TEST_DRIVE_CTA;
            CTA_CONFIGS.SHOW_TEST_DRIVE_CTA.isActive = true;
        }
        if (showCallOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CALL_CTA;
            CTA_CONFIGS.SHOW_CALL_CTA.isActive = true;
        }
        if (showChatOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CHAT_CTA;
            CTA_CONFIGS.SHOW_CHAT_CTA.isActive = true;
        }
        if (showWhatsAppCTA) {
            this.primaryCTA = CTA_MAP.SHOW_WHATSAPP_CTA;
            CTA_CONFIGS.SHOW_WHATSAPP_CTA.isActive = true;
        }

        if (isShowReservationButton) {
            // If isShowReservationButton is true, primaryCTA remains an empty string
            this.primaryCTA = '';
        }

        return CTA_CONFIGS;
    }

    render() {
        this.ctaConfigSetup = this.getCTAConfigs();
        return (
            <React.Fragment>
                { this.renderGalleryDescription() }
                { this.props.renderBookingModal() }
                { this.renderProfileDetailsMap() }
            </React.Fragment>
        );
    }
}

export const mapStateToProps = (state, ownProps) => ({
    isFeatured: getFeaturedAdSelector(state, ownProps)
});

export default compose(
    withConfig,
    injectIntl,
    withFeatureFlags,
    connect(mapStateToProps)
)(AdpvOld);
